import { render, staticRenderFns } from "./product_info.vue?vue&type=template&id=4231b44d"
import script from "./product_info.vue?vue&type=script&lang=js"
export * from "./product_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4231b44d')) {
      api.createRecord('4231b44d', component.options)
    } else {
      api.reload('4231b44d', component.options)
    }
    module.hot.accept("./product_info.vue?vue&type=template&id=4231b44d", function () {
      api.rerender('4231b44d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/customer_fee/form/product_info.vue"
export default component.exports